/* ==========================================================================
   La Papasada — Theme JS
   Scroll reveals, product slider, smooth scroll, loading screen, nav effects,
   mega menu, chatbot, countdown popup, location tabs
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- Loading Screen + Page Transition ---------- */
  var loader = document.querySelector('.loading-screen');
  var pageTransition = document.querySelector('.page-transition');
  var body = document.body;
  var isHomeTemplate = body && body.getAttribute('data-is-home') === 'true';
  var homeLoaderKey = 'papasada_home_loader_seen_v1';

  function disableLoader() {
    if (!loader) return;
    loader.classList.add('is-disabled');
    loader.classList.add('is-hidden');
  }

  function activatePageTransition() {
    if (!pageTransition) return;
    pageTransition.classList.add('is-active');
  }

  function deactivatePageTransition() {
    if (!pageTransition) return;
    pageTransition.classList.remove('is-active');
  }

  if (loader) {
    var shouldShowHomeLoader = false;

    try {
      shouldShowHomeLoader = isHomeTemplate && !window.localStorage.getItem(homeLoaderKey);
      if (shouldShowHomeLoader) window.localStorage.setItem(homeLoaderKey, '1');
    } catch (error) {
      shouldShowHomeLoader = isHomeTemplate;
    }

    if (!shouldShowHomeLoader) {
      disableLoader();
    } else {
      window.addEventListener('load', function() {
        setTimeout(function() {
          loader.classList.add('is-hidden');
        }, 800);
      });

      setTimeout(function() {
        if (loader) loader.classList.add('is-hidden');
      }, 3000);
    }
  }

  window.addEventListener('pageshow', function() {
    deactivatePageTransition();
    if (!isHomeTemplate) disableLoader();
  });

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.target && link.target !== '_self') return;
    if (link.hasAttribute('download')) return;

    var href = link.getAttribute('href');
    if (!href || href.indexOf('#') === 0) return;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
    if (link.getAttribute('rel') === 'external') return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    if (url.pathname.indexOf('/checkout') === 0) return;

    activatePageTransition();
  });

  /* ---------- Mobile Menu ---------- */
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavClose = document.getElementById('mobile-nav-close');

  if (menuToggle && mobileNav) {
    function setMobileMegaMenuState(accordion, isOpen) {
      if (!accordion) return;

      var toggle = accordion.querySelector('[data-mobile-mega-toggle]');
      var panel = accordion.querySelector('[data-mobile-mega-panel]');
      if (!toggle || !panel) return;

      accordion.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.hidden = !isOpen;
    }

    function setMobileMenuState(isOpen) {
      mobileNav.classList.toggle('is-open', isOpen);
      menuToggle.classList.toggle('is-open', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('mobile-menu-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';

      if (!isOpen) {
        mobileNav.querySelectorAll('[data-mobile-mega-menu]').forEach(function(accordion) {
          setMobileMegaMenuState(accordion, false);
        });
      }
    }

    menuToggle.addEventListener('click', function() {
      setMobileMenuState(!mobileNav.classList.contains('is-open'));
    });

    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', function() {
        setMobileMenuState(false);
      });
    }

    mobileNav.querySelectorAll('.mobile-nav__link').forEach(function(link) {
      link.addEventListener('click', function() {
        setMobileMenuState(false);
      });
    });

    mobileNav.querySelectorAll('[data-mobile-mega-menu]').forEach(function(accordion) {
      var toggle = accordion.querySelector('[data-mobile-mega-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function() {
        var isOpen = accordion.classList.contains('is-open');

        mobileNav.querySelectorAll('[data-mobile-mega-menu]').forEach(function(otherAccordion) {
          if (otherAccordion !== accordion) {
            setMobileMegaMenuState(otherAccordion, false);
          }
        });

        setMobileMegaMenuState(accordion, !isOpen);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setMobileMenuState(false);
      }
    });
  }

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  var header = document.querySelector('.header');
  var sectionHeader = document.querySelector('.section-header');

  if (header && sectionHeader) {
    var lastScrollY = 0;
    var scrollThreshold = 10; // minimum scroll delta to trigger
    var ticking = false;

    function updateHeader() {
      var currentScrollY = window.scrollY;
      var delta = currentScrollY - lastScrollY;

      // Add darkened bg when scrolled past hero
      if (currentScrollY > 50) {
        header.classList.add('nav-scrolled');
      } else {
        header.classList.remove('nav-scrolled');
      }

      // At very top: always show
      if (currentScrollY <= 10) {
        sectionHeader.classList.remove('header-hidden');
      }
      // Scrolling down past threshold: hide
      else if (delta > scrollThreshold) {
        sectionHeader.classList.add('header-hidden');
      }
      // Scrolling up past threshold: show
      else if (delta < -scrollThreshold) {
        sectionHeader.classList.remove('header-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- Mobile Order Bar: reveal on scroll up ---------- */
  (function() {
    var mobileOrderBar = document.querySelector('.mobile-order-bar');
    if (!mobileOrderBar) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    var lastScrollY = window.scrollY;
    var threshold = 12;

    function updateMobileOrderBar() {
      var currentScrollY = window.scrollY;
      var delta = currentScrollY - lastScrollY;

      if (currentScrollY < 80) {
        mobileOrderBar.classList.remove('is-visible');
      } else if (currentScrollY > 180) {
        mobileOrderBar.classList.add('is-visible');
      } else if (delta < -threshold) {
        mobileOrderBar.classList.add('is-visible');
      } else if (delta > threshold) {
        mobileOrderBar.classList.remove('is-visible');
      }

      lastScrollY = currentScrollY;
    }

    window.addEventListener('scroll', updateMobileOrderBar, { passive: true });
    updateMobileOrderBar();
  })();

  /* ---------- Mega Menu ---------- */
  document.querySelectorAll('[data-mega-menu-trigger]').forEach(function(trigger) {
    var megaMenu = trigger.querySelector('[data-mega-menu]');
    if (!megaMenu) return;

    var hideTimeout;

    trigger.addEventListener('mouseenter', function() {
      clearTimeout(hideTimeout);
      megaMenu.classList.add('is-visible');
    });

    trigger.addEventListener('mouseleave', function() {
      hideTimeout = setTimeout(function() {
        megaMenu.classList.remove('is-visible');
      }, 200);
    });

    // Keep menu open when hovering the menu itself
    megaMenu.addEventListener('mouseenter', function() {
      clearTimeout(hideTimeout);
    });

    megaMenu.addEventListener('mouseleave', function() {
      hideTimeout = setTimeout(function() {
        megaMenu.classList.remove('is-visible');
      }, 200);
    });
  });

  /* ---------- Scroll Reveal (GSAP-like) ---------- */
  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);

  function revealAllIn(root) {
    (root || document).querySelectorAll('.gsap-reveal, .fade-in').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  if (isDesignMode) {
    // In the Shopify theme editor, skip scroll-based animations entirely so
    // edited sections stay visible after re-render.
    revealAllIn(document);
    document.addEventListener('shopify:section:load', function(e) {
      revealAllIn(e.target);
    });
  } else {
    var revealElements = document.querySelectorAll('.gsap-reveal, .fade-in');
    if (revealElements.length > 0 && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -60px 0px'
      });

      revealElements.forEach(function(el) {
        revealObserver.observe(el);
      });
    } else {
      revealAllIn(document);
    }
  }

  /* ---------- Product Slider ---------- */
  document.querySelectorAll('[data-product-slider]').forEach(function(container) {
    var track = container.querySelector('[data-slider-track]');
    if (!track) return;

    if (window.matchMedia('(min-width: 768px)').matches) {
      container.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        e.preventDefault();
        container.scrollBy({
          left: e.deltaY,
          behavior: 'smooth'
        });
      }, { passive: false });
    }
  });

  /* ---------- Magnetic Button on Product Cards ---------- */
  if (window.matchMedia('(hover: hover)').matches) {
    document.querySelectorAll('.product-card__image').forEach(function(imageContainer) {
      var magneticBtn = imageContainer.querySelector('.magnetic-btn');
      if (!magneticBtn) return;

      imageContainer.addEventListener('mousemove', function(e) {
        var rect = imageContainer.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        magneticBtn.style.left = (x - magneticBtn.offsetWidth / 2) + 'px';
        magneticBtn.style.top = (y - magneticBtn.offsetHeight / 2) + 'px';
        magneticBtn.style.opacity = '1';
        magneticBtn.style.transform = 'scale(1) rotate(-8deg)';
      });

      imageContainer.addEventListener('mouseleave', function() {
        magneticBtn.style.opacity = '0';
        magneticBtn.style.transform = 'scale(0.5) rotate(-16deg)';
      });
    });
  }

  /* ---------- Countdown Timer ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function(timer) {
    var targetDate = new Date(timer.getAttribute('data-countdown') + 'T00:00:00').getTime();
    var daysEl = timer.querySelector('[data-days]');
    var hoursEl = timer.querySelector('[data-hours]');
    var minutesEl = timer.querySelector('[data-minutes]');
    var secondsEl = timer.querySelector('[data-seconds]');

    if (!daysEl) return;

    function update() {
      var now = Date.now();
      var diff = targetDate - now;

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  });

  /* ---------- Smooth Scroll for Anchor Links ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        var headerHeight = 80;
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ---------- Quantity Buttons (Product Page) ---------- */
  document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('[data-qty-input]');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('[data-qty-input]');
      if (input) {
        var max = parseInt(input.getAttribute('max')) || 99;
        if (parseInt(input.value) < max) {
          input.value = parseInt(input.value) + 1;
        }
      }
    });
  });

  /* ---------- Location Tabs ---------- */
  var locationTabs = document.querySelectorAll('[data-location-tab]');
  var locationPanels = document.querySelectorAll('[data-location-panel]');

  if (locationTabs.length > 0) {
    locationTabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = this.getAttribute('data-location-tab');

        // Update active tab
        locationTabs.forEach(function(t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');

        // Show corresponding panel
        locationPanels.forEach(function(panel) {
          if (panel.getAttribute('data-location-panel') === index) {
            panel.classList.remove('is-hidden');
            panel.hidden = false;
          } else {
            panel.classList.add('is-hidden');
            panel.hidden = true;
          }
        });
      });
    });
  }

  var socialProofConfig = (window.theme && window.theme.socialProof) || {};

  /* ---------- Countdown Popup ---------- */
  var popup = document.getElementById('countdown-popup');
  var popupClose = document.getElementById('countdown-popup-close');

  if (popup) {
    var popupDelay = parseInt(popup.getAttribute('data-delay'), 10) || 5000;
    var popupShown = sessionStorage.getItem('papasada_popup_shown');
    if (!popupShown) {
      setTimeout(function() {
        popup.classList.add('is-visible');
        popup.setAttribute('aria-hidden', 'false');
        sessionStorage.setItem('papasada_popup_shown', '1');
      }, popupDelay);
    }

    if (popupClose) {
      popupClose.addEventListener('click', function() {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
      });
    }

    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /* ---------- Delivery Coverage Checker ---------- */
  (function() {
    if (!window.theme || !window.theme.coverage || !window.theme.coverage.enabled) return;

    var storageKey = 'papasada_coverage_state_v1';
    var coverageConfig = window.theme.coverage;
    var launcher = document.getElementById('coverage-launcher');
    var launcherLabel = document.getElementById('coverage-launcher-label');
    var modal = document.getElementById('coverage-modal');
    var locateBtn = document.getElementById('coverage-locate-btn');
    var resetBtn = document.getElementById('coverage-reset-btn');
    var result = document.getElementById('coverage-result');
    var resultStatus = document.getElementById('coverage-result-status');
    var resultDetail = document.getElementById('coverage-result-detail');
    var zones = [];
    var coverageState = { status: 'unknown' };

    function parseZones() {
      if (!coverageConfig.zonesJson) return [];
      try {
        var parsed = JSON.parse(coverageConfig.zonesJson);
        if (!Array.isArray(parsed)) return [];
        return parsed
          .filter(function(zone) {
            if (!zone) return false;
            var hasPolygon = Array.isArray(zone.polygon) && zone.polygon.length >= 3;
            var hasCity = !!zone.city;
            return hasPolygon || hasCity;
          })
          .sort(function(a, b) {
            return (b.priority || 0) - (a.priority || 0);
          });
      } catch (error) {
        console.error('Coverage zones JSON is invalid:', error);
        return [];
      }
    }

    function normalizeValue(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    function loadState() {
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return { status: 'unknown' };
        return JSON.parse(raw);
      } catch (error) {
        return { status: 'unknown' };
      }
    }

    function saveState() {
      try {
        localStorage.setItem(storageKey, JSON.stringify(coverageState));
      } catch (error) {
        console.error('Unable to persist coverage state:', error);
      }
    }

    function openModal() {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (launcher) launcher.setAttribute('aria-expanded', 'true');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (launcher) launcher.setAttribute('aria-expanded', 'false');
    }

    function pointInPolygon(point, polygon) {
      var x = point[1];
      var y = point[0];
      var inside = false;

      for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        var xi = polygon[i][1];
        var yi = polygon[i][0];
        var xj = polygon[j][1];
        var yj = polygon[j][0];

        var intersects = ((yi > y) !== (yj > y)) &&
          (x < ((xj - xi) * (y - yi) / ((yj - yi) || 1e-9)) + xi);

        if (intersects) inside = !inside;
      }

      return inside;
    }

    function matchZone(lat, lng) {
      for (var i = 0; i < zones.length; i++) {
        if (pointInPolygon([lat, lng], zones[i].polygon)) return zones[i];
      }
      return null;
    }

    function matchZoneByCity(cityName) {
      var normalizedCity = normalizeValue(cityName);
      if (!normalizedCity) return null;

      for (var i = 0; i < zones.length; i++) {
        var zone = zones[i];
        if (!zone || !zone.city) continue;

        if (Array.isArray(zone.city)) {
          for (var j = 0; j < zone.city.length; j++) {
            if (normalizeValue(zone.city[j]) === normalizedCity) return zone;
          }
        } else if (normalizeValue(zone.city) === normalizedCity) {
          return zone;
        }
      }

      return null;
    }

    function extractPostalCode(value) {
      var match = (value || '').toString().match(/\b\d{5}\b/);
      return match ? match[0] : '';
    }

    function zoneMatchesPostal(zone, postalCode) {
      if (!zone || !postalCode) return false;

      if (Array.isArray(zone.postal_codes)) {
        for (var i = 0; i < zone.postal_codes.length; i++) {
          if ((zone.postal_codes[i] || '').toString() === postalCode) return true;
        }
      }

      if (Array.isArray(zone.postal_prefixes)) {
        for (var j = 0; j < zone.postal_prefixes.length; j++) {
          var prefix = (zone.postal_prefixes[j] || '').toString();
          if (prefix && postalCode.indexOf(prefix) === 0) return true;
        }
      }

      if (zone.postal_code && zone.postal_code.toString() === postalCode) return true;
      if (zone.postal_prefix && postalCode.indexOf(zone.postal_prefix.toString()) === 0) return true;

      return false;
    }

    function matchZoneByPostalCode(postalCode) {
      if (!postalCode) return null;
      for (var i = 0; i < zones.length; i++) {
        if (zoneMatchesPostal(zones[i], postalCode)) return zones[i];
      }
      return null;
    }

    function buildStateFromZone(matchedZone, payload) {
      payload = payload || {};

      if (!matchedZone) {
        return {
          status: 'unavailable',
          lat: payload.lat,
          lng: payload.lng,
          city: payload.city || '',
          postal_code: payload.postalCode || '',
          address: payload.address || '',
          formatted_address: payload.formattedAddress || ''
        };
      }

      if (matchedZone.mode === 'own_delivery') {
        return {
          status: 'own_delivery',
          lat: payload.lat,
          lng: payload.lng,
          city: payload.city || '',
          postal_code: payload.postalCode || '',
          address: payload.address || '',
          formatted_address: payload.formattedAddress || '',
          zone_id: matchedZone.id,
          zone_name: matchedZone.name
        };
      }

      if (matchedZone.mode === 'third_party') {
        return {
          status: 'third_party',
          lat: payload.lat,
          lng: payload.lng,
          city: payload.city || '',
          postal_code: payload.postalCode || '',
          address: payload.address || '',
          formatted_address: payload.formattedAddress || '',
          zone_id: matchedZone.id,
          zone_name: matchedZone.name,
          provider: matchedZone.provider || 'Glovo',
          provider_url: matchedZone.provider_url || coverageConfig.glovoUrl
        };
      }

      return {
        status: 'unavailable',
        lat: payload.lat,
        lng: payload.lng,
        city: payload.city || '',
        postal_code: payload.postalCode || '',
        address: payload.address || '',
        formatted_address: payload.formattedAddress || '',
        zone_id: matchedZone.id,
        zone_name: matchedZone.name
      };
    }

    function getActionForState() {
      if (coverageState.status === 'third_party') {
        return coverageState.provider_url || coverageConfig.glovoUrl || '';
      }
      return '';
    }

    function setResultUI() {
      if (!launcherLabel || !result || !resultStatus || !resultDetail) return;

      result.className = 'coverage-result coverage-result--' + coverageState.status;

      if (coverageState.status === 'own_delivery') {
        launcherLabel.textContent = 'Entrega propia: ' + (coverageState.zone_name || 'disponible');
        resultStatus.textContent = 'Entrega propia disponible';
        resultDetail.textContent = 'Llegamos con reparto propio a ' + (coverageState.zone_name || 'tu zona') + '.';
      } else if (coverageState.status === 'third_party') {
        launcherLabel.textContent = 'Disponible en ' + (coverageState.provider || 'Glovo');
        resultStatus.textContent = 'Cobertura con app externa';
        resultDetail.textContent = 'En ' + (coverageState.zone_name || 'tu zona') + ' solo repartimos con ' + (coverageState.provider || 'Glovo') + '.';
      } else if (coverageState.status === 'unavailable') {
        launcherLabel.textContent = 'Sin cobertura';
        resultStatus.textContent = 'Fuera de cobertura';
        resultDetail.textContent = 'Ahora mismo no repartimos en esta ubicación.';
      } else if (coverageState.status === 'locating') {
        launcherLabel.textContent = 'Localizando...';
        resultStatus.textContent = 'Comprobando ubicación';
        resultDetail.textContent = 'Estamos validando tu cobertura exacta.';
      } else if (coverageState.status === 'error') {
        launcherLabel.textContent = 'No se pudo comprobar';
        resultStatus.textContent = 'Error de ubicación';
        resultDetail.textContent = coverageState.message || 'No hemos podido obtener tu ubicación.';
      } else if (coverageState.status === 'city_hint') {
        launcherLabel.textContent = (coverageConfig.ipCityPrefix || 'Parece que estás en') + ' ' + (coverageState.city || coverageState.zone_name || '');
        resultStatus.textContent = 'Ciudad detectada por IP';
        resultDetail.textContent = coverageState.message || (coverageConfig.ipCityDetail || 'Comprueba tu ubicación exacta para confirmar si llegamos a tu zona.');
      } else {
        launcherLabel.textContent = coverageConfig.labelDefault || 'Comprueba tu zona';
        resultStatus.textContent = coverageConfig.statusDefault || 'Zona sin comprobar';
        resultDetail.textContent = coverageConfig.detailDefault || 'Usa tu ubicación exacta para validar si hacemos delivery propio, solo Glovo o si no hay cobertura.';
      }
    }

    function updateCoverageTargets() {
      document.querySelectorAll('[data-coverage-cta]').forEach(function(link) {
        if (!link.dataset.originalText) link.dataset.originalText = link.textContent.trim();
        if (!link.dataset.originalHref) link.dataset.originalHref = link.getAttribute('href') || '';

        link.removeAttribute('target');
        link.removeAttribute('rel');

        if (coverageState.status === 'own_delivery') {
          link.textContent = link.dataset.originalText;
          link.setAttribute('href', link.dataset.originalHref);
        } else if (coverageState.status === 'third_party') {
          link.textContent = 'PEDIR EN GLOVO';
          link.setAttribute('href', getActionForState() || link.dataset.originalHref);
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener');
        } else if (coverageState.status === 'unavailable') {
          link.textContent = 'SIN COBERTURA';
          link.setAttribute('href', '#');
        } else {
          link.textContent = 'COMPRUEBA TU ZONA';
          link.setAttribute('href', '#');
        }
      });

      document.querySelectorAll('[data-coverage-purchase]').forEach(function(button) {
        if (!button.dataset.originalHtml) button.dataset.originalHtml = button.innerHTML;
        if (!button.dataset.originalDisabled) button.dataset.originalDisabled = button.disabled ? 'true' : 'false';

        if (coverageState.status === 'own_delivery') {
          button.innerHTML = button.dataset.originalHtml;
          button.disabled = button.dataset.originalDisabled === 'true';
        } else if (coverageState.status === 'third_party') {
          button.innerHTML = 'PEDIR EN GLOVO';
          button.disabled = false;
        } else if (coverageState.status === 'unavailable') {
          button.innerHTML = 'FUERA DE COBERTURA';
          button.disabled = true;
        } else {
          button.innerHTML = 'COMPRUEBA TU ZONA';
          button.disabled = !!coverageConfig.requireCheck;
        }
      });
    }

    function applyState(newState) {
      coverageState = newState;
      saveState();
      setResultUI();
      updateCoverageTargets();
      document.dispatchEvent(new CustomEvent('papasada:coverage-change', {
        detail: coverageState
      }));
    }

    function evaluateCoverage(lat, lng, payload) {
      var matchedZone = matchZone(lat, lng);
      var nextState = buildStateFromZone(matchedZone, Object.assign({}, payload || {}, {
        lat: lat,
        lng: lng
      }));
      applyState(nextState);
      return nextState;
    }

    function evaluateCoverageByPostalCode(postalCode, payload) {
      var matchedZone = matchZoneByPostalCode(postalCode);
      var nextState = buildStateFromZone(matchedZone, Object.assign({}, payload || {}, {
        postalCode: postalCode
      }));
      applyState(nextState);
      return nextState;
    }

    function searchAddress(query) {
      if (!query) return Promise.resolve([]);

      var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&limit=5&countrycodes=es&q=' + encodeURIComponent(query);

      return fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('address_lookup_failed');
          return response.json();
        })
        .then(function(results) {
          if (!Array.isArray(results)) return [];
          return results.map(function(item) {
            var address = item.address || {};
            return {
              label: item.display_name,
              lat: parseFloat(item.lat),
              lng: parseFloat(item.lon),
              city: address.city || address.town || address.village || address.suburb || '',
              postalCode: address.postcode || extractPostalCode(item.display_name),
              raw: item
            };
          }).filter(function(item) {
            return !isNaN(item.lat) && !isNaN(item.lng);
          });
        });
    }

    function validateDeliveryAddress(payload) {
      payload = payload || {};
      var address = (payload.address || '').trim();
      var postalCode = extractPostalCode(payload.postalCode || payload.address || '');
      var city = (payload.city || '').trim();
      var parts = [address, postalCode, city, 'Barcelona', 'España'].filter(Boolean);
      var query = parts.join(', ');

      if (postalCode) {
        var postalMatch = matchZoneByPostalCode(postalCode);
        if (postalMatch) {
          var postalState = buildStateFromZone(postalMatch, {
            postalCode: postalCode,
            address: address,
            city: city,
            formattedAddress: address
          });
          applyState(postalState);
          return Promise.resolve(postalState);
        }
      }

      if (!query) {
        return Promise.resolve({
          status: 'error',
          message: 'Introduce una dirección o un código postal válido.'
        });
      }

      return searchAddress(query).then(function(results) {
        if (!results.length) {
          var errorState = {
            status: 'error',
            message: 'No hemos podido encontrar esa dirección. Revisa la calle o el código postal.'
          };
          applyState(errorState);
          return errorState;
        }

        var match = results[0];
        return evaluateCoverage(match.lat, match.lng, {
          address: address,
          postalCode: match.postalCode || postalCode,
          city: match.city || city,
          formattedAddress: match.label
        });
      }).catch(function() {
        var fallbackState = {
          status: 'error',
          message: 'No hemos podido validar la dirección ahora mismo. Prueba con tu código postal o usa tu ubicación.'
        };
        applyState(fallbackState);
        return fallbackState;
      });
    }

    function locateUser() {
      if (!navigator.geolocation) {
        applyState({
          status: 'error',
          message: 'Tu navegador no permite geolocalización.'
        });
        return;
      }

      applyState({ status: 'locating' });

      navigator.geolocation.getCurrentPosition(function(position) {
        evaluateCoverage(position.coords.latitude, position.coords.longitude);
      }, function(error) {
        var message = 'No hemos podido obtener tu ubicación.';
        if (error && error.code === error.PERMISSION_DENIED) {
          message = 'Has bloqueado el permiso de ubicación.';
        }
        applyState({ status: 'error', message: message });
      }, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000
      });
    }

    function detectCityByIp() {
      if (!coverageConfig.ipLookupEnabled || !coverageConfig.ipLookupUrl) return;
      if (coverageState.status && coverageState.status !== 'unknown') return;

      fetch(coverageConfig.ipLookupUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('ip_lookup_failed');
          return response.json();
        })
        .then(function(data) {
          if (!data) return;

          var city = data.city || data.cityName || data.regionName || '';
          var country = data.country || data.countryCode || '';
          if (!city) return;

          var matchedCityZone = matchZoneByCity(city);
          var message = (coverageConfig.ipCityPrefix || 'Parece que estás en') + ' ' + city;
          if (country) message += ', ' + country;
          message += '. ' + (coverageConfig.ipCityDetail || 'Comprueba tu ubicación exacta para confirmar si llegamos a tu zona.');

          applyState({
            status: 'city_hint',
            city: city,
            country: country,
            zone_id: matchedCityZone ? matchedCityZone.id : '',
            zone_name: matchedCityZone ? matchedCityZone.name : city,
            message: message
          });
        })
        .catch(function(error) {
          console.warn('IP lookup unavailable:', error);
        });
    }

    function guardPurchase() {
      if (coverageState.status === 'own_delivery') return true;
      if (coverageState.status === 'third_party') {
        var redirectUrl = getActionForState();
        if (redirectUrl) window.open(redirectUrl, '_blank', 'noopener');
        return false;
      }
      openModal();
      return false;
    }

    zones = parseZones();
    coverageState = loadState();
    setResultUI();
    updateCoverageTargets();
    if (coverageConfig.ipLookupAutoDetect) {
      detectCityByIp();
    }

    if (launcher) {
      launcher.addEventListener('click', openModal);
    }

    document.querySelectorAll('[data-coverage-open]').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    });

    if (modal) {
      modal.querySelectorAll('[data-coverage-close]').forEach(function(node) {
        node.addEventListener('click', closeModal);
      });
    }

    if (locateBtn) locateBtn.addEventListener('click', locateUser);
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        applyState({ status: 'unknown' });
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    document.addEventListener('click', function(e) {
      var coverageLink = e.target.closest('[data-coverage-cta]');
      if (!coverageLink) return;

      if (coverageState.status === 'own_delivery') return;

      if (coverageState.status === 'third_party') {
        e.preventDefault();
        var targetUrl = getActionForState();
        if (targetUrl) window.open(targetUrl, '_blank', 'noopener');
        return;
      }

      e.preventDefault();
      openModal();
    });

    document.querySelectorAll('[data-coverage-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        if (!guardPurchase()) e.preventDefault();
      });
    });

    window.themeCoverage = {
      getState: function() {
        return coverageState;
      },
      openChecker: openModal,
      guardPurchase: guardPurchase,
      locateUser: locateUser,
      searchAddress: searchAddress,
      validateDeliveryAddress: validateDeliveryAddress,
      applyState: applyState,
      evaluateCoverageByPostalCode: evaluateCoverageByPostalCode
    };
  })();

  /* ==========================================================================
     ENHANCED UX — All Tier 1/2/3 Features
     ========================================================================== */

  /* ---------- 1. Custom Cursor ---------- */
  (function() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var cursor = document.getElementById('custom-cursor');
    if (!cursor) return;

    var mouseX = 0, mouseY = 0;
    var cursorX = 0, cursorY = 0;

    document.body.classList.add('cursor-active');

    document.addEventListener('mousemove', function(e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!cursor.classList.contains('is-visible')) {
        cursor.classList.add('is-visible');
      }
    });

    // Smooth follow with lerp
    function animateCursor() {
      cursorX += (mouseX - cursorX) * 0.4;
      cursorY += (mouseY - cursorY) * 0.4;
      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      requestAnimationFrame(animateCursor);
    }
    animateCursor();

    // Hover states
    var hoverTargets = 'a, button, [role="button"], input, textarea, select, .btn, .product-card__add-btn, .header__nav-link, .header__cta-btn';
    var cardTargets = '.product-card, .wizard__base-card';

    document.addEventListener('mouseover', function(e) {
      if (e.target.closest(cardTargets)) {
        cursor.classList.add('is-hovering-card');
        cursor.classList.remove('is-hovering');
      } else if (e.target.closest(hoverTargets)) {
        cursor.classList.add('is-hovering');
        cursor.classList.remove('is-hovering-card');
      }
    });

    document.addEventListener('mouseout', function(e) {
      if (e.target.closest(hoverTargets) || e.target.closest(cardTargets)) {
        cursor.classList.remove('is-hovering', 'is-hovering-card');
      }
    });

    // Hide when mouse leaves window
    document.addEventListener('mouseleave', function() {
      cursor.classList.remove('is-visible');
    });
  })();

  /* ---------- 2. Char Stagger Text Animation ---------- */
  (function() {
    var headings = document.querySelectorAll('.section-heading__title, .hero__title, .wizard__step-title');

    headings.forEach(function(heading) {
      if (heading.classList.contains('char-stagger')) return;

      // Save original HTML to handle spans (like .text-primary, .hero__title-accent)
      var children = heading.childNodes;
      var newHTML = '';

      function splitWordsAndChars(text) {
        var words = text.split(/(\s+)/);
        var result = '';
        for (var w = 0; w < words.length; w++) {
          if (/^\s+$/.test(words[w])) {
            result += ' ';
          } else {
            result += '<span class="word">';
            for (var c = 0; c < words[w].length; c++) {
              result += '<span class="char">' + words[w][c] + '</span>';
            }
            result += '</span>';
          }
        }
        return result;
      }

      children.forEach(function(node) {
        if (node.nodeType === 3) {
          newHTML += splitWordsAndChars(node.textContent);
        } else if (node.nodeType === 1) {
          var tag = node.tagName.toLowerCase();
          var cls = node.className ? ' class="' + node.className + '"' : '';
          newHTML += '<' + tag + cls + '>' + splitWordsAndChars(node.textContent) + '</' + tag + '>';
        }
      });

      heading.innerHTML = newHTML;
      heading.classList.add('char-stagger');

      // Apply stagger delays
      var chars = heading.querySelectorAll('.char');
      chars.forEach(function(ch, i) {
        ch.style.transitionDelay = (i * 25) + 'ms';
      });
    });

    // Use IntersectionObserver to trigger
    if ('IntersectionObserver' in window) {
      var charObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            charObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.char-stagger').forEach(function(el) {
        charObserver.observe(el);
      });
    }
  })();

  /* ---------- 3. 3D Tilt on Product Cards ---------- */
  (function() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    document.querySelectorAll('[data-product-card]').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var rotateX = (y - 0.5) * -10;
        var rotateY = (x - 0.5) * 10;
        card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-8px)';
        card.style.boxShadow = '0 25px 50px rgba(201, 48, 48, 0.15)';
      });

      card.addEventListener('mouseleave', function() {
        card.style.transform = '';
        card.style.boxShadow = '';
      });
    });
  })();

  /* ---------- 4. Product Quick View ---------- */
  (function() {
    var modal = document.querySelector('[data-product-quick-view]');
    if (!modal) return;

    var body = modal.querySelector('[data-product-quick-view-body]');
    var lastFocusedElement = null;

    function closeQuickView() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('product-quick-view-open');
      if (body) body.innerHTML = '';
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function openQuickView(card, trigger) {
      if (!card || !body) return;

      var template = card.querySelector('[data-product-quick-view-template]');
      if (!template) return;

      lastFocusedElement = trigger || document.activeElement;
      body.innerHTML = template.innerHTML;

      var title = body.querySelector('.product-quick-view__title');
      if (title) title.id = 'product-quick-view-title';

      modal.hidden = false;
      document.body.classList.add('product-quick-view-open');

      var closeBtn = modal.querySelector('[data-product-quick-view-close]');
      if (closeBtn) closeBtn.focus();
    }

    document.addEventListener('click', function(e) {
      var infoBtn = e.target.closest('[data-product-quick-view-open]');
      if (infoBtn) {
        e.preventDefault();
        e.stopPropagation();
        openQuickView(infoBtn.closest('[data-product-card]'), infoBtn);
        return;
      }

      if (e.target.closest('[data-product-quick-view-close]')) {
        e.preventDefault();
        closeQuickView();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeQuickView();
      }
    });
  })();

  /* ---------- 5. Parallax Hero Background ---------- */
  (function() {
    var heroBg = document.querySelector('.hero__bg');
    if (!heroBg) return;

    var heroSection = heroBg.closest('.hero');
    if (!heroSection) return;

    heroBg.classList.add('parallax-bg');

    window.addEventListener('scroll', function() {
      var rect = heroSection.getBoundingClientRect();
      if (rect.bottom < 0) return; // off screen
      var scrolled = window.scrollY;
      var speed = 0.4;
      heroBg.style.transform = 'translateY(' + (scrolled * speed) + 'px) scale(1.1)';
    }, { passive: true });

    // Initial scale to prevent gap
    heroBg.style.transform = 'scale(1.1)';
  })();

  /* ---------- 6. Social Proof Toasts ---------- */
  (function() {
    var toast = document.getElementById('social-proof');
    if (!toast) return;

    var nameEl = document.getElementById('social-proof-name');
    var detailEl = document.getElementById('social-proof-detail');
    var timeEl = document.getElementById('social-proof-time');

    var names = Array.isArray(socialProofConfig.names) && socialProofConfig.names.length ? socialProofConfig.names : ['Maria G.', 'Carlos R.', 'Laura M.', 'Javi T.', 'Ana B.', 'Pedro S.', 'Sofia L.', 'Diego F.', 'Elena V.', 'Marc P.'];
    var products = Array.isArray(socialProofConfig.products) && socialProofConfig.products.length ? socialProofConfig.products : ['Bacon Cheddar', 'Pulled Pork', 'Veggie Deluxe', 'Texana BBQ', 'Mediterranea', 'Hazla a tu Rollo'];
    var times = Array.isArray(socialProofConfig.times) && socialProofConfig.times.length ? socialProofConfig.times : ['hace 2 min', 'hace 5 min', 'hace 8 min', 'hace 12 min', 'hace 15 min', 'ahora mismo'];
    var prefix = socialProofConfig.prefix || 'ha pedido una';

    function showToast() {
      var name = names[Math.floor(Math.random() * names.length)];
      var product = products[Math.floor(Math.random() * products.length)];
      var time = times[Math.floor(Math.random() * times.length)];

      nameEl.textContent = name;
      detailEl.textContent = prefix + ' ' + product;
      timeEl.textContent = time;

      toast.classList.add('is-visible');

      setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 4000);
    }

    // First toast after 12s, then every 15-25s
    setTimeout(function() {
      showToast();
      setInterval(function() {
        showToast();
      }, 15000 + Math.random() * 10000);
    }, 12000);
  })();

  /* ---------- 13. Scroll Progress Indicator ---------- */
  (function() {
    var progressBar = document.getElementById('scroll-progress');
    if (!progressBar) return;

    window.addEventListener('scroll', function() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var progress = scrollTop / docHeight;
      progressBar.style.transform = 'scaleX(' + progress + ')';
    }, { passive: true });
  })();

  /* ---------- 15. Fly-to-Cart Animation ---------- */
  (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-card__add-btn, [data-add-to-cart-quick]');
      if (!btn) return;
      if (btn.hasAttribute('data-wizard-link')) return;

      var card = btn.closest('.product-card');
      if (!card) return;

      var img = card.querySelector('img');
      if (!img) return;

      var ctaBtn = document.querySelector('.header__cta-btn');
      if (!ctaBtn) return;

      var imgRect = img.getBoundingClientRect();
      var targetRect = ctaBtn.getBoundingClientRect();

      var dot = document.createElement('div');
      dot.className = 'fly-to-cart';
      dot.style.left = (imgRect.left + imgRect.width / 2) + 'px';
      dot.style.top = (imgRect.top + imgRect.height / 2) + 'px';
      document.body.appendChild(dot);

      // Force reflow
      dot.offsetHeight;

      // Animate to target
      var dx = targetRect.left + targetRect.width / 2 - (imgRect.left + imgRect.width / 2);
      var dy = targetRect.top + targetRect.height / 2 - (imgRect.top + imgRect.height / 2);

      dot.style.transition = 'all 0.7s cubic-bezier(0.16, 1, 0.3, 1)';
      dot.style.left = (imgRect.left + imgRect.width / 2 + dx) + 'px';
      dot.style.top = (imgRect.top + imgRect.height / 2 + dy) + 'px';
      dot.style.transform = 'scale(0.2)';
      dot.style.opacity = '0';

      setTimeout(function() {
        dot.remove();
        // Pulse the CTA button
        ctaBtn.style.transform = 'scale(1.15)';
        setTimeout(function() {
          ctaBtn.style.transform = '';
        }, 200);
      }, 700);
    });
  })();

  /* ---------- Allergen Filter Toggle ---------- */
  (function() {
    var filters = document.querySelectorAll('[data-allergen-filter]');
    if (filters.length === 0) return;

    var cards = document.querySelectorAll('[data-product-card]');

    filters.forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.classList.toggle('is-active');

        var activeFilters = [];
        filters.forEach(function(f) {
          if (f.classList.contains('is-active')) {
            activeFilters.push(f.getAttribute('data-allergen-filter'));
          }
        });

        // If no filters active, show all
        if (activeFilters.length === 0) {
          cards.forEach(function(card) {
            card.style.display = '';
            card.style.opacity = '1';
          });
          return;
        }

        cards.forEach(function(card) {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          var show = activeFilters.some(function(filter) {
            return tags.indexOf(filter) !== -1;
          });
          card.style.display = show ? '' : 'none';
          card.style.opacity = show ? '1' : '0';
        });
      });
    });
  })();

})();
